import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import React from "react";
import {
  getProblematicTreatmentLinks,
  hasProblematicTreatment,
} from "../calendar";

export default function ProblematicTreatment({ client }) {
  const links = getProblematicTreatmentLinks(client);

  if (!hasProblematicTreatment(client)) {
    return null;
  }

  return (
    <Tooltip
      title={
        links.length === 0
          ? null
          : links.map((l, i) => (
              <a
                key={i}
                href={l}
                target="_blank"
                rel="noreferrer"
                style={{
                  display: "inline-block",
                }}
              >
                {l}
              </a>
            ))
      }
    >
      <FontAwesomeIcon
        icon={faCircleExclamation}
        color="var(--mui-palette-warning-indicator)"
      />
    </Tooltip>
  );
}
